/* global wolky_edit_user_ajax_data  */
(function ($) {
  function deactivateUser() {
    let modal = $('#ws-disable-customer-modal');

    /* When the disable button is clicked, open the "are you sure" modal*/
    $('#deactivate-customer-from-cd').on('click', function(e) {
      e.preventDefault();

      modal.removeClass('hidden');
      modal.addClass('flexbox');
    });

    /* When clicked "No" close the modal */
    $('#ws-disable-option-no').on('click', function(e) {
      e.preventDefault();
      modal.removeClass('flexbox');
      modal.addClass('hidden');
    });

    /* When clicked "Yes" make ajax call */
    $('#ws-disable-option-yes').on('click', function(e) {
      e.preventDefault();

      var $this  = $(this),
        data = {
          'editingUserId': wolky_edit_user_ajax_data.editing_user_id,
          'editorUserId': wolky_edit_user_ajax_data.editor_user_id,
          'nonce':   wolky_edit_user_ajax_data.deactivate_nonce,
        };

      var dactivateCustomer = wp.ajax.post('deactivate_customer_from_cd', data);

      dactivateCustomer.done( function(response) {
        //addInlineNotice($this, true, response)
        replaceContent(response);
      });

      dactivateCustomer.fail( function(response) {
        addInlineNotice($this, false, response)
      });
    });
  }

  function transferPoints() {
    $('#new-transaction-button').on('click', function(e) {
      e.preventDefault();
      let points = $('#transaction-input').val();
      let reason = $('#transaction-reason').val();
      var $this  = $(this),
      data = {
        'editingUserId': wolky_edit_user_ajax_data.editing_user_id,
        'editorUserId': wolky_edit_user_ajax_data.editor_user_id,
        'nonce':   wolky_edit_user_ajax_data.transaction_nonce,
        'points': points,
        'reason': reason,
      };

      var newTransaction = wp.ajax.post('create_new_transaction', data);

      newTransaction.done( function(response) {
        //addInlineNotice($this, true, response)
        replaceContent(response);
      });

      newTransaction.fail( function(response) {
        addInlineNotice($this, false, response)
      });
    });
  }

  function newStoreCredit() {
    $('#new-store-credit-button').on('click', function(e) {
      e.preventDefault();
      let storeCredit = $('#store-credit-input').val();
      let reason = $('#new-store-credit-reason').val();
      var $this  = $(this),
      data = {
        'editingUserId': wolky_edit_user_ajax_data.editing_user_id,
        'editorUserId': wolky_edit_user_ajax_data.editor_user_id,
        'nonce':   wolky_edit_user_ajax_data.balance_nonce,
        'storeCredit': storeCredit,
        'reason': reason,
      };

      var newStoreCredit = wp.ajax.post('create_new_store_credit', data);

      newStoreCredit.done( function(response) {
        //addInlineNotice($this, true, response)
        replaceContent(response);
      });

      newStoreCredit.fail( function(response) {
        addInlineNotice($this, false, response)
      });
    });
  }

  function deleteBalance() {
    $('.delete-balance').on('click', function(e) {
      e.preventDefault();

      let balanceId = $(this).attr('name');

      var $this  = $(this),
        data = {
          'editingUserId': wolky_edit_user_ajax_data.editing_user_id,
          'editorUserId': wolky_edit_user_ajax_data.editor_user_id,
          'nonce':   wolky_edit_user_ajax_data.delete_balance_nonce,
          'balanceId': balanceId,
        };

      var deleteBalance = wp.ajax.post('delete_balance', data);

      deleteBalance.done( function(response) {
        //addInlineNotice($this, true, response)
        replaceContent(response);
      });

      deleteBalance.fail( function(response) {
        addInlineNotice($this, false, response)
      });

    });
  }

  function addInlineNotice( $this, success, message ) {
    let settingsElement = $('.Wolkyshop-cd-settings');
    var resultDiv = $( '<div />' );

    // Set up the notice div.
    resultDiv.addClass( 'notice inline' );

    // Add a class indicating success or failure.
    resultDiv.addClass( 'notice-' + ( success ? 'success' : 'error' ) );

    // Add the message, wrapping in a p tag, with a fadein to highlight each message.
    resultDiv.text( $( $.parseHTML( message ) ).text() ).wrapInner( '<p />');

    // Disable the button when the callback has succeeded.
    $this.prop( 'disabled', success );

    // Remove any previous notices.
    $this.siblings( '.notice' ).remove();

    // Insert the notice.
    resultDiv.insertBefore(settingsElement);

    $(window).scrollTop(resultDiv.position().top);
  }

  function replaceContent(html) {
    $('#wolkyshop-customerdb-container').replaceWith(html);
    deactivateUser();
    transferPoints();
    newStoreCredit();
    deleteBalance();
  }

  deactivateUser();
  transferPoints();
  newStoreCredit();
  deleteBalance();
})(jQuery);
